import {AbstractModel, JsonObject, JsonProperty} from '../../../../../../core/src/public-api';
import {ShortProject} from '../../project-misc/data/project/short-project';
import {ShortObject} from '../../project-misc/data/project/short-json-object';

@JsonObject('model.PricingOptionShort')
export class PricingOptionShort extends AbstractModel {

  @JsonProperty(Number, 'id')
  id: number;

  @JsonProperty(String, 'name')
  name: string;

  @JsonProperty(Boolean, 'active')
  active: boolean;
}
